<template>
  <div class="notification-detail-page">

    <div v-if="!userIsMeldkamerMedewerker">
      <div class="row" >
        <div class="col">
          <div class="box">
              <h4><b>Smartwatch: </b> {{ selectedNotification.smartwatchName }}</h4>
              <h4><b>Cliënt: </b> {{ selectedNotification.clientInitials }}</h4>
              <h4><b>Type alarmering: </b> {{ selectedNotification.notificationType }}</h4>
              <h4><b>Tijdstip alarmering: </b> {{ selectedNotification.serverTime | toSimpleDateFormat }}</h4>
              <h4><b>Telefoonnummer smartwatch: </b> {{ selectedNotification.smartwatchPhoneNumber }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="div"  v-if="userIsMeldkamerMedewerker">
      <div class="row">
        <div class="col">
          <div class="box">
            <h4><b>Gegevens alarmering</b></h4>
            <h4><b>Smartwatch: </b> {{ selectedNotification.smartwatchName }}</h4>
            <h4><b>Type alarmering: </b> {{ selectedNotification.notificationType }}</h4>
            <h4><b>Tijdstip alarmering: </b> {{ selectedNotification.serverTime | toSimpleDateFormat }}</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="box">
            <h4><b>Gegevens woonlocatie cliënt</b></h4>
            <h4><b>Woonlocatie naam: </b>{{ walk.client.location.locationName }}</h4>
            <h4><b>Plaats: </b>{{ walk.client.location.city }}</h4>
            <h4><b>Straat: </b>{{ walk.client.location.streetName }} {{ walk.client.location.streetNumber }}</h4>
            <h4><b>Postcode: </b>{{ walk.client.location.postalCode }}</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="box">
              <h4><b>Bellijst woonlocatie cliënt</b></h4>
              <h4><b>Woonlocatie cliënt: </b> {{ walk.client.location.phoneNumber }}</h4>
              <h4 v-for="contact in walk.client.location.contacts" :key="contact.id"><b>{{ contact.contactName }}:</b> {{ contact.phoneNumber }}</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button-component
                  :submitted="this.submitted"
                  @click.native="onAlarmFinishedClick">
            Alarmering overgedragen
          </button-component>
        </div>
      </div>
    </div>

    <div class="row" v-if="!userIsMeldkamerMedewerker && !walkIsLoading">
      <div class="col">
        <div class="box">
          <h4>Instellingen wijzigen</h4>
          <datetime v-model="walk.walkSettings.endTime"
                    type="datetime"
                    input-id="startDate"
                    zone="local"
                    value-zone="local"
                    input-style="width: 100%;
                                  border: 1px solid #d8dbe1;
                                  border-radius: 3px;
                                  height: 52px;
                                  padding: 1rem;">
            <label for="startDate" slot="before">Eindtijd</label>
          </datetime>
          <h4 style="margin-top: 2rem;">Wijzig het gebied</h4>
          <input-component
              type="number"
              label="Marge in aantal meters"
              v-model="marginInMeters">
          </input-component>
          <h4 class="errorMessage" v-if="noValidClientLocationAvailabie">{{ noValidClientLocationAvailableMessage }}</h4>
          <gmap-map
                  :center="center"
                  :zoom="10"
                  style="width: 100%; height: 650px;"
                  id="map"
                  ref="map">
            <gmap-marker :position="this.clientIcon.position" :icon="clientIcon" :draggable="false"></gmap-marker>
            <gmap-marker
                    v-for="(marker, index) in locationsOfInterst"
                    :key="index"
                    :position="marker.position"
                    :label="marker.title"
                    :draggable="false"
                    @click="onMarkerClicked(marker, index)">
            </gmap-marker>
            <gmap-polygon :path="areaWithMargin" @click="onPolygonClicked($event)">
            </gmap-polygon>
          </gmap-map>
          <button-component
                  :submitted="this.submitted"
                  @click.native="onSaveClick"
                  style="margin-top: 2rem;">
            Instellingen opslaan
          </button-component>
          <button-component
                  :submitted="this.submitted"
                  @click.native="onAlarmFinishedClick">
            Alarmering afgehandeld
          </button-component>
        </div>
      </div>
    </div>
    <MapMarkerDetails
            v-show="showMapMarkerDetails"
            v-bind:header="modalHeaderText"
            v-bind:body="modalBodyText"
            v-bind:markerLatLngData="markerLatLngData"
            v-bind:buttonLeft="modalButtonLeft"
            v-bind:buttonRight="modalButtonRight"
            @onCloseModalClicked="onCloseModalClicked"
            @onSaveMarkerClicked="onSaveMarkerClicked">
    </MapMarkerDetails>
  </div>
</template>

<script>
  import { Notification } from "@/domain/notification";
  import { Datetime } from 'vue-datetime';
  import ButtonComponent from '../components/button.component.vue';
  import InputComponent from '../components/fields/input.component.vue';
  import MapMarkerDetails from '../components/map.marker.details.vue';
  import { Walk } from "../domain/walk";
  import LocationService from  '../services/location.service';
  import { WalkSettings } from "../domain/walk.settings";
  import axios from 'axios';
  import { AppConfig, RouteName } from "../utils/enums";
  import SockJS from 'sockjs-client';
  import Stomp from 'webstomp-client';
  import { Role } from '../utils/enums';

  const locationService = new LocationService();
  const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export default {
  name: 'notification-detail-page',
  components: {
    Datetime,
    ButtonComponent,
    MapMarkerDetails,
    InputComponent
  },
  data() {
    return {
      selectedNotification: Notification,
      walk: Walk,
      center: {},
      locationsOfInterst: [],
      areaWithMargin: [],
      clientIcon: {},
      walkIsLoading: true,
      submitted: false,
      showMapMarkerDetails: false,
      noValidClientLocationAvailabie: false,
      noValidClientLocationAvailableMessage: 'Let op: Er is geen huidige GPS-locatie van de cliënt beschikbaar',
      marginInMeters: 1, // default
      // Modal data
      modalHeaderText: 'Nieuwe locatie toevoegen' ,
      modalBodyText: 'Voer de naam van de locatie waar de cliënt naartoe wilt in:',
      modalButtonLeft: 'Annuleren',
      modalButtonRight: 'Opslaan',
      markerLatLngData: undefined,
        // websocket
        socket: {},
        stompClient: {}
    }
  },
  watch: {
    // recalculate the geofence when the marginInMeters is changed
    marginInMeters: function () {
      // total area, with the calculated margin included
      const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.marginInMeters);
      // the total area (geoFence) with marging around the locations
      this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
    }
  },
  created() {
    this.selectedNotification = this.$store.getters.getSelectedNotification;
    // subscribe to api for live location updates
    this.connectWebsocket();
    // geldige locatie ontvangen, toon op de map
    if (this.selectedNotification.lastLocation.lat > 0 && this.selectedNotification.lastLocation.lng > 0) {
      this.noValidClientLocationAvailabie = false;
      this.center = { lat: this.selectedNotification.lastLocation.lat, lng: this.selectedNotification.lastLocation.lng };
      this.clientIcon = {
        path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0",
        fillColor: 'blue',
        fillOpacity: .6,
        position: { lat: this.center.lat, lng: this.center.lng }
      };
    }
    else { // geen geldige locatie beschikbaar -> toon melding
      this.noValidClientLocationAvailabie = true;
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
    this.fetchWalkDetails();
  },
  computed: {
    userIsMeldkamerMedewerker() {
      return this.$store.getters.getUserGroups.includes(Role.MELDKAMER_MEDEWERKER);
    }
  },
  methods: {
    fetchWalkDetails: function () {
      axios.get(apiUrl + AppConfig.API_WALKS_URL + "/" + this.selectedNotification.walkId)
                .then(response => {
                  this.walk = response.data;
                  this.walkIsLoading = false;
                  this.marginInMeters = this.walk.walkSettings.marginInMeters;
                  // small timeout needed to init the map after the data is fetched
                  const initMap = () => setTimeout (() => {
                    this.mapGeoLocations();
                    this.mapLocationsOfInterest();
                    this.$refs.map.$mapPromise.then((map) => {
                      map.addListener('click', (event) => {
                        this.markerLatLngData = event.latLng;
                        this.showMapMarkerDetails = true;
                      });
                    });
                  }, 450);
                  initMap();
                });
      },
      connectWebsocket() {
          this.socket = new SockJS(apiUrl + AppConfig.API_WEBSOCKET_REGISTER_URL);
          this.stompClient = Stomp.over(this.socket);
          this.stompClient.connect({ walkId: this.selectedNotification.walkId }, () => {
                  this.stompClient.subscribe(AppConfig.API_WEBSOCKET_NOTIFICATIONS_URL + "/" + this.selectedNotification.walkId, data => {
                      const locationData = JSON.parse(data.body);
                      this.handleIncomingLocationData(locationData);
                  });
              },
              error => {
                  console.error(error);
                  this.disconnectWebsocket();
              }
          );
      },
      handleIncomingLocationData(locationData) {
        if (locationData.lat > 0 && locationData.lng > 0) {
            this.noValidClientLocationAvailabie = false;
            this.clientIcon = {
                path: "M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0", // circle
                fillColor: 'blue',
                fillOpacity: .6,
                position: { lat: locationData.lat, lng: locationData.lng }
            };
        }
        else {
            this.noValidClientLocationAvailabie = true;
        }
      },
    disconnectWebsocket() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
    },
    mapGeoLocations: function() {
      this.walk.walkSettings.geoPoints.forEach(geoPoint => {
        this.areaWithMargin.push({ lat: geoPoint.lat, lng: geoPoint.lng });
      });
    },
    mapLocationsOfInterest: function() {
      this.walk.walkSettings.locationsOfInterest.forEach(location => {
        const point = new google.maps.LatLng(location.lat, location.lng);
        this.locationsOfInterst.push({ title: location.title, position: point});
      });
    },
    onMarkerClicked: function(marker, index) {
      if (marker.title === 'Woonlocatie') {
        return;
      }
      this.locationsOfInterst.splice(index, 1); // remove marker from the map
      // total area, with the calculated margin included
      const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.walk.walkSettings.marginInMeters);
      // the total area (geoFence) with marging around the locations
      this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
    },
    onPolygonClicked: function(event) {
      this.markerLatLngData = event.latLng;
      this.showMapMarkerDetails = true;
    },
    addMarker: function(location, locationName) {
      // selected locations
      this.locationsOfInterst = [...locationService.addMarker(location, this.locationsOfInterst, locationName)];
      // total area, with the calculated margin included
      const locationsWithMargin = locationService.addMarginPointsAroundMarker(this.locationsOfInterst, this.walk.walkSettings.marginInMeters);
      // the total area (geoFence) with marging around the locations
      this.areaWithMargin = locationService.calculateGeoFence(locationsWithMargin);
    },
    onSaveMarkerClicked: function(markerData, locationName) {
      this.addMarker(markerData, locationName);
      this.showMapMarkerDetails = false;
    },
    onCloseModalClicked: function() {
      this.showMapMarkerDetails = false;
    },
    onSaveClick: function() {
      this.submitted = true;
      // map the locationsOfInterst from google.map.LatLng's to a geoPoint object
      this.walk.walkSettings.locationsOfInterest = this.locationsOfInterst.map(location => {
        return {
          title: location.title,
          lat: location.position.lat(),
          lng: location.position.lng()
        };
      });
      this.walk.walkSettings.geoPoints = this.areaWithMargin;
      this.walk.walkSettings.marginInMeters = this.marginInMeters;
      this.$store.dispatch('UPDATE_WALK', this.walk)
              .then(response => {
                if (response.status === 200) {
                  window.scrollTo(0,0);
                  this.submitted = false;
                }
              });
    },
    onAlarmFinishedClick: function () {
      this.$store.dispatch('SET_NOTIFICATION_HANDLED', this.selectedNotification.id)
              .then(response => {
                if (response.status === 200) {
                  this.$router.push({ name: RouteName.NOTIFICATIONS });
                }
              });
    }
  }
};
</script>

<style scoped lang="scss">
  @import "../../node_modules/vue-datetime/dist/vue-datetime.css";
.notification-detail-page {
  .row {
    flex-direction: column;

    @include desktop {
      flex-direction: row;
    }
  }

  .box {
    margin-bottom: .5rem;

    @include desktop {
      background-color: $white;
      padding: 1rem;
      box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0.25rem;
    }

    h4 {
      font-weight: 400;
      margin-bottom: .2rem;
      color: $gray-darkest;
    }

    p {
      color: $gray-dark;
    }

    .errorMessage {
      color: $red;
      font-weight: bold;
    }

  }
}
</style>
